import { combineReducers } from 'redux';
import profile from './profile';
import { StateDefaultProfilePublicType } from './types';

const reducer = combineReducers<StateDefaultProfilePublicType>({ profile });

export default reducer;
